// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jsvJ","type":"styles_type__3k99z","choices":"styles_choices__k3HIo"};